export var source_navigation = { "uid": "source_navigation", "fields": { "title": { "defaultValue": "" }, "menu_name": { "defaultValue": "" }, "url": { "defaultValue": "" } } };
